export async function openActivateChannelPermissionsUrl(url: string, callback?: () => void) {
	window.location.href = url;
}
